import React, { Component } from "react"

/* REST API */
import { get } from "../api/Organization"

/* Constants */
import { utils, env } from "../constants"

/* Components */
import { Button, Modal, Loading, Header, Avatar } from "../components"

/* Icons */
import { StarFilled } from "@ant-design/icons"

/* Pages */
import Members from "./Members"

/* Widgets */
import { Top } from "../widgets/Review"

/* Copy */
import { CopyToClipboard } from 'react-copy-to-clipboard'

/* Swal */
import Swal from 'sweetalert2'

const items = [
    { key: "services", text: "Услуги" },
    { key: "information", text: "Информация" },
    { key: "members", text: "Специалисты" },
    { key: "reviews", text: "Отзывы" },
    { key: "images", text: "Фото" }
]

/* Fields */
const pathname = window.location.search
const uid = pathname.length > 1 ? pathname.substring(1) : ""


/* Organization Page */
class Organization extends Component {

    constructor() {
        super()

        this.state = {
            loading: false,
            uid: uid,
            data: null,
            selected: null,
            modalSelected: null,
            isVisible: false,
            menu: "services"
        }
    }

    componentDidMount = () => {
        this.load()
    }


    /* Load Action */
    load = () => {

        /* Fields */
        const { uid } = this.state

        /* Send to REST API */
        get({ uid }).then(response => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data, loading: false })
                document.title = utils.checkValue(response.data.name, "Bookify – Удобный способ записи на услуги")
            }
            else {
                this.setState({ status: "error", data: null, loading: false })
            }
        }).catch(() => {
            this.setState({ status: "network", data: null, loading: false })
        })

    }

    /* Book */
    bookCheck = () => {
        this.setState({ isVisible: true })
    }

    /* Set Service in modal */
    setService = () => {

        /* Fields */
        const { modalSelected } = this.state

        if (!modalSelected) {
            utils.toggleError("Выберите услугу", "error", "serviceId")
        }
        else {
            this.setState({ selected: modalSelected })
        }

    }

    /* Copy */
    copy = () => {
        Swal.fire({
            html: `<p class="notification">Ссылка успешна скопирована</p>`,
            color: 'white',
            background: 'black',
            showConfirmButton: false,
            position: 'top',
            timer: 1000,
            backdrop: false,
            width: 300
        })
    }

    /* Get active box */
    getBox = () => {

        const { menu, data } = this.state

        if (menu === "services") {
            return this._services()
        }

        if (menu === "information") {
            return this._information()
        }

        if (menu === "members") {
            return this._members()
        }

        if (menu === "reviews") {
            return this._reviews()
        }

        // if (menu === "images") {
        //     return <ReviewPhoto id={data.id} />
        // }

        return null

    }

    /* Render services */
    _services = (scroll = false) => {

        const { data, selected, modalSelected } = this.state

        const selectedId = scroll ? modalSelected : selected

        const select = (id) => {
            if (scroll) {
                this.setState({ modalSelected: id })
            } else {
                this.setState({ selected: id })
            }
        }

        /* Check */
        if (data.services && Array.isArray(data.services)) {

            /* Empty */
            if (data.services.length === 0) {
                return <div>Пусто</div>
            }

            return (
                <div className={`service-list ${scroll ? "scroll" : ""}`}>
                    {data.services.map((item, index) =>
                        <div className="service-box" key={`service-${index}`} onClick={() => select(item.id)}>
                            <div className="service-name">{item.name}</div>
                            <div className="service-price">{utils.convertor(item.price)}</div>
                            <div className="check-box">
                                <div className={`check-round ${selectedId === item.id ? "checked" : ""}`}>
                                    {selectedId === item.id ? <div className="check-circle" /> : null}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )

        }
    }

    /* Render information */
    _information = () => {

        const { data } = this.state

        return (
            <div className="or-information">

                {utils.checkValue(data.description, null) && <p className="top-text">{data.description}</p>}

                {utils.checkValue(data.phone, null) ?
                    <a href={`tel:${data.phone}`}>
                        <div className="about-block">
                            <div className="about-icon">
                                <img src="/images/phone.png" alt="icon" />
                            </div>
                            <div className="about-inform">
                                <p className="label">Телефон</p>
                                <p className="inform-text">{data.phone}</p>
                            </div>
                        </div>
                    </a>
                    : null
                }

                {utils.checkValue(data.phone, null) ? <div className="bottom-line-divider" /> : null}

                {utils.checkValue(data.instagram, null) ?
                    <a href={`tel:${data.instagram}`}>
                        <div className="about-block">
                            <div className="about-icon">
                                <img src="/images/instagram.png" alt="icon" />
                            </div>
                            <div className="about-inform">
                                <p className="label">Инстаграм</p>
                                <p className="inform-text">{data.instagram}</p>
                            </div>
                        </div>
                    </a>
                    : null
                }

                {data.paymentMethods && Array.isArray(data.paymentMethods) && data.paymentMethods.length > 0 && <p className="top-text methods">Способы оплаты</p>}

                {data.paymentMethods && Array.isArray(data.paymentMethods) && data.paymentMethods.length > 0 &&
                    <div className='paymentMethods'>
                        {data.paymentMethods.map((item, index) =>
                            <div key={`${index}`} className='paymentMethod'>
                                <img src={`${env.point}/payments/${item.image}`} className="payment" alt="payment" />
                                <p>{item.name}</p>
                            </div>
                        )}
                    </div>
                }

            </div>
        )

    }

    /* Members */
    _members = () => {

        const { data } = this.state

        /* Check */
        if (data.members && Array.isArray(data.members)) {
            /* Empty */
            if (data.members.length === 0) {
                return (
                    <div className="empty">
                        <p>Здесь пусто</p>
                    </div>
                )
            }

            return (
                <div className="members-column">
                    {
                        data.members.map((item, index) => {
                            const style = index === data.members.length - 1 ? "last" : ""
                            return (
                                <div className={`member-column ${style}`}>
                                    <Avatar src={item.image} size={40} />
                                    <div className="member-inform">
                                        <div className="member-name">{item.name}</div>
                                        <div className="member-rating">
                                            <img src="/images/star.png" alt="star" />
                                            <p>{Number(item.rating).toFixed(2)}</p>
                                            {parseInt(item.reviews) > 0 && <p>({item.reviews} отзыв{parseInt(item.reviews) === 1 ? "" : parseInt(item.reviews) <= 4 ? "а" : "ов"})</p>}
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            )
        }

        return null
    }

    /* Reviews */
    _reviews = () => {

        const { data } = this.state

        return (
            <div className="reviews">

                {/* Top Rating */}
                <Top data={data} />
                {/* 
                {data.reviewsList.map((item, index) =>
                    <Review navigation={navigation} data={item} key={`${index}`} />
                )}

                {data.reviewsList.length > 0 &&
                    <TouchableOpacity onPress={() => navigation.navigate("AllReviews", { id: data.id })}>
                        <Text center top={15} bottom={10} bold color={theme.colors.primary}>Все отзывы</Text>
                    </TouchableOpacity>
                } */}

            </div>
        )
    }

    /* Render Modal */
    _renderModal = () => {
        const { data, selected, } = this.state

        if (!selected) {
            return (
                <div className="modal-content">
                    {this._services(true)}
                    <div className="bottom-button">
                        <Button text="Далее" onClick={() => this.setService()} />
                    </div>
                </div>
            )
        } else {
            return (
                <Members organizationID={data.id} serviceID={selected} />
            )
        }
    }

    render = () => {

        const { data, loading, isVisible, selected, modalSelected, menu } = this.state

        const url = `${env.shareLink}/?${uid}`
        const urltext = `${data ? data.name : ""}\n${url}`

        if (loading || !data) {
            return <Loading />
        }

        return (
            <div className="organization">

                {/* Draw Header */}
                <Header />

                {/* Organization Information */}
                <div className="information">
                    <div className="head">

                        <div className="name">
                            <p className="or-name">{data.name}</p>
                            <div className="row">
                                <StarFilled style={{ fontSize: "16px", color: "#ff9800" }} />
                                <p className="bold">{Number(data.rating).toFixed(2)}</p>
                                {parseInt(data.reviews) > 0 && <p>({data.reviews} отзыв{parseInt(data.reviews) === 1 ? "" : parseInt(data.reviews) <= 4 ? "а" : "ов"})</p>}
                            </div>
                        </div>
                        <CopyToClipboard text={urltext}>
                            <div className="share" onClick={() => this.copy()}>
                                <img src="/images/share.png" alt="share" />
                            </div>
                        </CopyToClipboard>
                    </div>

                    <div className="location">
                        <img src="/images/location.png" alt="location" />
                        <div className="address">
                            <span>Адрес</span>
                            <p>{data.address}</p>
                        </div>
                        <a href={`tel:${data.phone}`}>
                            <div className="phone">
                                <img src="/images/call.png" alt="phone" />
                            </div>
                        </a>
                    </div>
                </div>

                {/* Services */}
                <div className="services">
                    <div className="header-scroll">
                        {
                            items.map(item => {
                                return (
                                    <div className={`scroll-item ${menu === item.key ? "selected" : ""}`} key={item.key} onClick={() => this.setState({ menu: item.key })}>
                                        {item.text}
                                    </div>
                                )
                            })
                        }
                    </div>
                    {this.getBox()}
                </div>

                <Modal visible={isVisible} backVisible={selected && modalSelected} goBack={() => this.setState({ selected: null })} close={() => this.setState({ isVisible: false, selected: modalSelected ? null : selected, modalSelected: null })} >
                    {this._renderModal()}
                </Modal>

                {
                    !isVisible ?
                        <div className="bottom-button">
                            <Button text="Записаться" onClick={() => this.bookCheck()} />
                        </div>
                        : null
                }

            </div>
        )



    }

}

export default Organization